import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/auth/Login';
// components
import LoadingScreen from '../components/LoadingScreen';
import CaravanAgentInformation from 'src/pages/caravanAgent/Information';
import EAgent from 'src/pages/caravanAgent/enum';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children, isPublic }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const admin = useSelector((store) => store.admin);
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  
  if (admin.isLoading) {
    return <LoadingScreen />;
  }

  if(EAgent?.agent_id?.includes(admin?.data?.agent?.id) && admin?.data?.image === ""){
    return <CaravanAgentInformation /> 
  }
  
  if (!isAuthenticated && !isPublic) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
